<!--
showVal:对象中显示中文字符的key
slotsKey:循环调用组，传入当前第几个
setList 设置列表数据
-->
<template>
    <div class="line" ref="box"
         @mousedown="doTouchstart" @touchstart="doTouchstart"
         @mouseup="doTouchend" @touchend="doTouchend">
        <ul :style="{'transform': 'translate3d(0, '+ dance +'px, 0)'}">
            <li></li>
            <li></li>
            <li v-for="(item,index) in listArr"
                v-bind:key="index"
                :class="item.active?'active':''">
                {{item.name}}
            </li>
            <li></li>
            <li></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "child-slot",
        data() {
            return {
                direction: 'up',
                startx: Number,
                starty: Number,
                yStart: Number,
                yEnd: Number,
                listLiH: 0,
                dance: 0,
                maxDance: Number,
                listArr: [],
                mobile: true
            }
        },
        props: {
            slotsKey: Number
        },
        created() {
            if ("ontouchstart" in window) {
                this.mobile = true
            } else {
                this.mobile = false
            }
        },
        methods: {
            //获得角度
            getAngle(angx, angy) {
                return Math.atan2(angy, angx) * 180 / Math.PI;
            },
            //根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
            getDirection(startx, starty, endx, endy) {
                var angx = endx - startx;
                var angy = endy - starty;
                var result = 0;
                //如果滑动距离太短
                if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
                    return result;
                }
                var angle = this.getAngle(angx, angy);
                if (angle >= -135 && angle <= -45) {
                    result = 1;
                } else if (angle > 45 && angle < 135) {
                    result = 2;
                } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
                    result = 3;
                } else if (angle >= -45 && angle <= 45) {
                    result = 4;
                }
                return result;
            },
            doTouchstart(e) {
                if (this.mobile) {
                    this.startx = e.touches[0].pageX;
                    this.starty = e.touches[0].pageY;
                    this.yStart = e.touches[0].pageY;
                }
                else {
                    this.startx = e.pageX;
                    this.starty = e.pageY;
                    this.yStart = e.pageY;
                }
            },
            doTouchend(e) {
                var endx, endy;
                if (this.mobile) {
                    endx = e.changedTouches[0].pageX;
                    endy = e.changedTouches[0].pageY;
                    this.yEnd = e.changedTouches[0].pageY;
                }
                else {
                    endx = e.pageX;
                    endy = e.pageY;
                    this.yEnd = e.pageY;
                }

                var direction = this.getDirection(this.startx, this.starty, endx, endy);
                switch (direction) {
                    case 0:
                        break;
                    case 1:
                        this.doMove('up')
                        break;
                    case 2:
                        this.doMove('down')
                        break;
                    case 3:
                        break;
                    case 4:
                        break;
                    default:
                }
            },
            // up  OR  down
            doMove(direction) {
                // if (this.listArr.length == 0) return
                var $end = this.yEnd, $start = this.yStart,
                    $dance = +($start) - +($end),
                    $multiple = Math.ceil(Math.abs($dance) / this.listLiH)
                if (direction == 'up') {
                    var $hUp = (this.listLiH * $multiple) + Math.abs(this.dance)
                    if ($hUp > this.maxDance) {
                        this.dance = -this.maxDance
                    } else {
                        this.dance = -$hUp
                    }
                }
                else if (direction == 'down') {
                    var $hDown = Math.abs(this.dance) - (this.listLiH * $multiple)
                    if ($hDown < 0) {
                        this.dance = 0
                    } else {
                        this.dance = -$hDown
                    }
                }
                var $index = Math.abs(this.dance) / this.listLiH
                this.setVal($index)
            },
            setVal(index) {
                var $listData = this.listArr
                $listData.map(function (item) {
                    if (item.active) {
                        delete item.active;
                    }
                })
                $listData[index]['active'] = true
                this.listArr = $listData
                this.$emit('eventPicker', {chooseVal: $listData[index], index: this.slotsKey})
            },
            /* setList
            * data 数组
            * index 焦点位置
            * */
            setList(data, index) {
                this.listArr = data
                this.setVal(index)
                this.listLiH = this.$refs.box.offsetHeight / 5;
                this.maxDance = (this.listArr.length - 1) * this.listLiH
                this.dance = -(this.listLiH * index)
            }


        }
    }
</script>

<style scoped lang="less">
    @theme: #4877bd;
    .line {
        position: relative;
        z-index: 2;
        flex: 1;
        width: 100%;
        height: 200px;
        ul {
            width: 100%;
            height: 200px;
            transition: all .5s;
            li {
                width: 100%;
                height: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 40px;
                text-align: center;
                font-size: 14px;
                opacity: .5;
                color: #666;
                transition: all .3s;
                &.active {
                    color: #333;
                    opacity: 1;
                }
            }
        }
    }

</style>